import { boticarioTheme, fidelidadeBelezaNaWebTheme } from '@grupoboticario/flora'

export const businessUnitTheme = {
  gb: fidelidadeBelezaNaWebTheme,
  gbpt: fidelidadeBelezaNaWebTheme,
  'venda-direta': boticarioTheme
}
